module.exports = __webpack_public_path__ + "static/media/1.9c303f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/600646/1.jpg
// module id = 686
// module chunks = 0